import { render } from "./NotificationsItem.vue?vue&type=template&id=b11a6cfa&scoped=true"
import script from "./NotificationsItem.vue?vue&type=script&lang=js"
export * from "./NotificationsItem.vue?vue&type=script&lang=js"

import "./NotificationsItem.vue?vue&type=style&index=0&id=b11a6cfa&lang=scss"
import "./NotificationsItem.vue?vue&type=style&index=1&id=b11a6cfa&scoped=true&lang=scss"
import "./NotificationsItem.vue?vue&type=style&index=2&id=b11a6cfa&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b11a6cfa"]])

export default __exports__